import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { lawyerSelectors } from "../redux/lawyer/selectors";
import { Feature, LITE_PLAN_TYPE } from "../types/entitlements";

/**
 * Plan-derived feature access.
 *
 * When the backend has not reported entitlements (older API, session not yet
 * loaded, or a failed fetch) every feature is treated as available, so the UI
 * degrades to today's behavior rather than blanking out.
 */
export const useEntitlements = () => {
  const entitlements = useSelector(lawyerSelectors.selectEntitlements);

  const featureSet = useMemo(
    () => (entitlements ? new Set(entitlements.features) : null),
    [entitlements]
  );

  const hasFeature = useCallback(
    (feature: Feature) => (featureSet ? featureSet.has(feature) : true),
    [featureSet]
  );

  return {
    hasFeature,
    planType: entitlements?.planType ?? null,
    isLitePlan: entitlements?.planType === LITE_PLAN_TYPE,
    hasResolvedEntitlements: Boolean(entitlements)
  };
};
